import { render, staticRenderFns } from "./form-links.vue?vue&type=template&id=00b6fa4a&scoped=true"
import script from "./form-links.vue?vue&type=script&lang=js"
export * from "./form-links.vue?vue&type=script&lang=js"
import style0 from "./form-links.vue?vue&type=style&index=0&id=00b6fa4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6fa4a",
  null
  
)

export default component.exports